import { ApiService } from '../apiService'

/** Counts for the Support hub — see SupportController on the API. */
export interface SupportModerationSummary {
  /** Unclaimed system tickets (site moderators only). */
  ticketQueue: number
  /** Unclaimed tickets reported to groups the viewer owns or admins. */
  groupTicketQueue: number
  /** Unfinished tickets claimed by or assigned to the viewer. */
  claimedByYou: number
  /** Suggestions waiting for review across the platform (site moderators only). */
  pendingContributions: number
  /** Trails whose route edit is waiting for approval: everywhere for site moderators, in-region for regional ones. */
  pendingTrailRoutes: number
  /** Whether the ticket queue applies (site moderators and group owners/admins). */
  canModerateTickets: boolean
  /** Whether trail route review applies (site and regional moderators). */
  canReviewTrails: boolean
}

export interface SupportSummary {
  /** The viewer's own tickets that are not Resolved or Closed. */
  openTickets: number
  /** The viewer's own tickets waiting on the viewer to reply. */
  ticketsAwaitingYou: number
  /** The viewer's suggestions still waiting for a moderator. */
  pendingSuggestions: number
  /**
   * Other people's suggestions waiting for the viewer to accept or reject: all of them for a site
   * moderator, otherwise those on adventures the viewer manages. Counted in attentionCount. Absent
   * on an older API.
   */
  suggestionsToReview?: number
  /** What the nav badge shows: things waiting on the viewer to act. */
  attentionCount: number
  /** Null unless the viewer moderates something. */
  moderation: SupportModerationSummary | null
}

export const supportApi = {
  getSummary: () => ApiService.get<SupportSummary>('/api/support/summary'),
}

export const SUPPORT_QUERY_KEYS = {
  summary: ['support', 'summary'] as const,
}
